import React from "react"
import classNames from "classnames";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheckCircle, faBars, faX } from '@fortawesome/free-solid-svg-icons';

library.add(faCheckCircle, faBars, faX);

const NioIcon = (props) =>{
    let icon =  'ni-'+ props.icon;
    return(
        <em className={['ni','icon', icon, props.className ? props.className : null].join(' ')}></em>
    )
}


const SocialIcon = (props) =>{
    return(
        <ul className={['social', props.className ? props.className : null].join(' ')}>
                {props.data.map((data,index) =>
                    <li key={index}><a href={data.to} onClick={(ev) => ev.preventDefault()}><NioIcon icon={data.icon}/></a></li>
                )}
        </ul>
    )
}

const StyledIcon = (props) =>{
    return(
        <div className={['styled-icon', props.className ? props.className : null].join(' ')}>
                {props.children}
        </div>
            
    )
}

const Icon = ({ name, id = null, className = null, style = null, size = "xl", iconType, ...props }) => {
  if (iconType === "fa")
  {
    return <FontAwesomeIcon icon={name} size={size} fixedWidth={true} color={props.color} />
  }
  const iconClass = classNames({
    [`${className}`]: className,
    icon: true,
    ni: true,
    [`ni-${name}`]: true,
  });
  return <em className={iconClass} id={id} style={style} {...props}></em>;
};


export {NioIcon, SocialIcon, StyledIcon, Icon}
